var map = {
	"./Pay_QrCode.jpg": "a114",
	"./banner_cgw.jpg": "b548",
	"./banner_xlh.jpg": "0af1",
	"./banner_zxyp.jpg": "5cce",
	"./banner_zyb.jpg": "3be0",
	"./car.jpg": "f5c2",
	"./doct.jpg": "ae5c",
	"./goods01.jpg": "66c6",
	"./goods02.jpg": "31aa",
	"./goods03.jpg": "f633",
	"./goods04.jpg": "0cce",
	"./page1.jpg": "8f4e",
	"./page2.jpg": "127e",
	"./page4.jpg": "d0a3",
	"./page5.jpg": "5ad7",
	"./page6.jpg": "a7bc",
	"./productIcon/anquanjiaoyu.jpg": "94bb",
	"./productIcon/aqy.jpg": "8b0f",
	"./productIcon/chexian.jpg": "77be",
	"./productIcon/didi.jpg": "8e10",
	"./productIcon/eleme.jpg": "5e67",
	"./productIcon/gaode.jpg": "aaa8",
	"./productIcon/jd.jpg": "79ad",
	"./productIcon/kugou.jpg": "ac77",
	"./productIcon/lipei.jpg": "40e3",
	"./productIcon/meituan.jpg": "6051",
	"./productIcon/mg.jpg": "f28e",
	"./productIcon/naixue.jpg": "07d8",
	"./productIcon/qqhy.jpg": "ee7f",
	"./productIcon/qqyy.jpg": "873f",
	"./productIcon/souhu.jpg": "c89d",
	"./productIcon/starCharge.jpg": "fd7a",
	"./productIcon/starbucks.jpg": "d04a",
	"./productIcon/t3.jpg": "8e07",
	"./productIcon/tx.jpg": "caf0",
	"./productIcon/wyy.jpg": "5462",
	"./productIcon/xicha.jpg": "6eb0",
	"./productIcon/xl.jpg": "bfd3",
	"./productIcon/youku.jpg": "18b6",
	"./renzheng.jpg": "ff65",
	"./sfzyq.jpg": "7562",
	"./shop_address.jpg": "58cc",
	"./shops_d.jpg": "6410",
	"./user_bg.jpg": "59db",
	"./watchVideo/bg.jpg": "397b",
	"./watchVideo/xlh_logo.jpg": "e1f0",
	"./微信图片_20210120095049.jpg": "32b9",
	"./微信图片_20210120095110.jpg": "0acf",
	"./微信图片_20210120095641.jpg": "9b63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";